var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 4,
  width: 24,
  height: 17,
  rx: 2,
  fill: "#EEEEEE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5165 12.4377C15.8915 12.4459 16.2686 12.4211 16.6421 12.4505C17.0204 12.5211 17.1116 13.0937 16.7755 13.2813C16.5462 13.4048 16.2738 13.3273 16.0252 13.3491H15.5165V12.4377ZM16.859 11.4061C16.9423 11.7002 16.6588 11.9643 16.3755 11.9238H15.5165C15.5225 11.6464 15.5047 11.3454 15.5252 11.0827C15.8693 11.0924 16.2167 11.0629 16.5588 11.0981C16.7058 11.135 16.8289 11.2559 16.859 11.4061ZM18.9264 7.04494C18.9424 7.60657 18.9287 8.19788 18.9333 8.7709C18.9323 11.1006 18.9356 13.4302 18.9315 15.76C18.9164 16.6332 18.1426 17.3918 17.2756 17.4092C16.4077 17.4128 15.5396 17.4098 14.6716 17.4108V13.8887C15.6174 13.8839 16.5636 13.8987 17.509 13.8814C17.9475 13.8538 18.4279 13.5645 18.4483 13.0818C18.4999 12.5971 18.043 12.2619 17.6091 12.2089C17.4423 12.2046 17.4472 12.1603 17.6091 12.141C18.0229 12.0516 18.3479 11.6233 18.2261 11.1943C18.1224 10.7432 17.6237 10.5686 17.209 10.5695C16.3633 10.5637 15.5175 10.5687 14.6718 10.567C14.6773 9.90947 14.6604 9.25124 14.6809 8.59421C14.7479 7.73686 15.5411 7.02983 16.396 7.04517C17.2396 7.04504 18.0831 7.04504 18.9264 7.04501V7.04494Z",
  fill: "url(#paint0_linear_1902_9436)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.11502 8.68317C5.13662 7.81144 5.91371 7.059 6.77966 7.04626C7.64436 7.04359 8.50918 7.04587 9.37388 7.0451C9.3715 9.96171 9.37856 12.8786 9.37032 15.7951C9.33701 16.6562 8.56839 17.3943 7.71188 17.4096C6.84554 17.4127 5.97911 17.41 5.11274 17.4109V13.7701C5.95427 13.9689 6.83675 14.0536 7.69525 13.9217C8.20842 13.8391 8.76989 13.5871 8.94363 13.0547C9.07148 12.5993 8.9995 12.12 9.01853 11.6526V10.5671H7.53281C7.52613 11.2851 7.54648 12.0042 7.52206 12.7213C7.48201 13.162 7.04553 13.442 6.62986 13.4271C6.11434 13.4325 5.09278 13.0535 5.09278 13.0535C5.09022 11.7084 5.10774 10.0239 5.11502 8.68329V8.68317Z",
  fill: "url(#paint1_linear_1902_9436)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.92783 11.0051C9.84963 11.0217 9.91211 10.7388 9.89212 10.6314C9.89744 9.95268 9.88098 9.27321 9.9012 8.59496C9.96801 7.73399 10.7674 7.02519 11.6257 7.04534H14.1534C14.1511 9.96195 14.1581 12.8789 14.1499 15.7953C14.1165 16.6565 13.3479 17.3945 12.4913 17.4098C11.625 17.4131 10.7585 17.4103 9.89208 17.4112V13.4222C10.4838 13.9077 11.288 13.9833 12.0252 13.9846C12.581 13.9844 13.1335 13.8987 13.6732 13.7706V13.0398C13.065 13.3429 12.35 13.5355 11.6758 13.3613C11.2054 13.2442 10.864 12.7897 10.8716 12.3043C10.8171 11.7996 11.113 11.2667 11.609 11.1166C12.2249 10.9238 12.8961 11.0712 13.4734 11.3219C13.5971 11.3867 13.7226 11.467 13.6732 11.2603V10.6859C12.7077 10.4562 11.6802 10.3716 10.7102 10.6215C10.4294 10.7007 10.1559 10.8208 9.92783 11.0052V11.0051Z",
  fill: "url(#paint2_linear_1902_9436)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1902_9436",
  x1: 14.6425,
  y1: 12.0062,
  x2: 18.9065,
  y2: 12.0062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B03A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#55B330"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1902_9436",
  x1: 5.02208,
  y1: 12.3273,
  x2: 9.30401,
  y2: 12.3273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F6EB6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006DBA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1902_9436",
  x1: 9.88583,
  y1: 12.107,
  x2: 14.1527,
  y2: 12.107,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE0D3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E30138"
})));

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.5be4a1c63e0d2b13fed82a3329a8494f.svg";
export { ForwardRef as ReactComponent };